module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-chunk-header-01@2x.1bcf8444.jpg";